<template>
  <div ref="resultView">
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer ">
      <div class="appraisal-center fonts marr" style="margin-top: 10px;width: 100%">
        <el-tabs class="on_tous_sdas" v-model="resultMode" @tab-click="handleTabClick">
          <el-tab-pane label="纬度结果设置" name="jzjg"></el-tab-pane>
          <el-tab-pane label="认知风格设置" name="xgjg"></el-tab-pane>
          <el-tab-pane label="流体&晶体组合" name="lljg"></el-tab-pane>
        </el-tabs>
        <template v-if="resultMode=='jzjg'">
          <div>
            <span>类型：</span>
            <span>
              <el-tag
                  :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                  v-for="(item, index) in getWDData"
                  :key="item.examDimensionId"
                  @click="activeEvent(item, 'level1',index);"
                  effect="plain"
              > {{ item.name }}</el-tag>
            </span> 
          </div>
          <div style="margin-top: 20px">
            <span>纬度一：</span>
            <span>
            <el-tag
                :class="{ 'tag-marr': true,'tag-marrs': true, 'active-bg1': tagJzIndex == index }"
                v-for="(item, index) in getJZData"
                :key="index"
                @click="activeEvent(item, 'level2',index)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
          </div>
          <div style="margin-top: 20px">
            <el-button type="success" size="small" @click="handleClick('add')"
            >添加结果<i class="el-icon-plus"></i
            ></el-button>
          </div>
          <div style="margin-top: 20px">
            <div class="public-table-data">
              <el-table ref="multipleTable" size="medium"
                  :data="getWdResulData"
                  border
                  style="width: 100%"
                  row-key="menuId" v-loading="loading">
                <el-table-column type="index" label="序号" width="60" align="center" ></el-table-column>
                <el-table-column prop="minScore" label="最小值" width="80" align="center" ></el-table-column>
                <el-table-column prop="maxScore" label="最大值" width="80" align="center"></el-table-column>
                <el-table-column prop="name" label="标题" width="100" align="center"></el-table-column>
                <el-table-column prop="name" label="状态" width="100" align="center">
                  <template slot-scope="scope">
                    <div class="content_div" v-html="scope.row.title"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="content" label="说明"  min-width="220" align="center">
                  <template slot-scope="scope">
                    <div class="content_div">{{ setHtmlData(scope.row.content) }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="content" label="关键词"  min-width="220" align="center" >
                  <template slot-scope="scope">
                    <div class="content_div">{{ setHtmlData(scope.row.keyword) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="180"
                >
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleClick('edit', scope.row)"
                        type="primary"
                        plain
                    >编辑
                    </el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleDelete(scope.row)"
                        type="danger"
                        plain
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
        <template v-if="resultMode=='xgjg'">
          <div class="topic-outer" v-loading="loading" style="padding-bottom: 30px">
            <el-empty description="暂无数据" v-if="noContentJz"></el-empty>
            <div v-else class="appraisal-center fonts marr">
              <template v-if="initJZData">
                <el-tabs
                    tab-position="left"
                    v-model="activeName"
                    @tab-click="handleChangClick"
                >
                  <el-tab-pane
                      v-for="item in initJZData"
                      :key="item[0].examResultId"
                      :label="item[0].code"
                      :name="item[0].examResultId.toString()"
                  >
                  </el-tab-pane>
                  <div>
                    <div class="public-dialog-form">
                      <el-form
                          ref="ruleForm"
                          :rules="contentrules"
                          label-width="110px"
                      >
                        <el-tabs type="card" v-model="languageCode" @tab-click="resultHandleTabClick">
                          <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                                      :key="index"></el-tab-pane>
                        </el-tabs>
                        <el-row>
                          <!-- <el-col :span="12">
                            <el-form-item label="核心能力" prop="content">
                              <rich-text :keyWord="'content'"
                                         :params="stepdata1?stepdata1:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="思维模式" prop="descr">
                              <rich-text :keyWord="'descr'"
                                         :params="stepdata1?stepdata1:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="典型优势" prop="advantageDesc">
                              <rich-text :keyWord="'advantageDesc'"
                                         :params="stepdata1?stepdata1:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="潜在劣势" prop="weaknessDesc">
                              <rich-text :keyWord="'weaknessDesc'"
                                         :params="stepdata1?stepdata1:''"></rich-text>
                            </el-form-item>
                            <el-form-item label="发展建议" prop="suggest">
                              <rich-text :keyWord="'suggest'"
                                         :params="stepdata1?stepdata1:''"></rich-text>
                            </el-form-item>
                          </el-col> -->
                          <el-col :span="12">
                            <div class="items">
                              <div class="item-head">
                                <el-form-item label-width="40px">
                                  <el-button type="primary" plain>直觉型</el-button>
                                  <el-form-item label="人格类型名称" style="width: 70%;display: inline-block;margin: 0;">
                                    <el-input placeholder="请填写人格类型名称" v-model="stepdata2.keyword"></el-input>
                                  </el-form-item>
                                </el-form-item>
                              </div>
                              <el-form-item label="解读" >
                                <rich-text :keyWord="'suggest2'"
                                          :params="stepdata2?stepdata2:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="典型优势" >
                                <rich-text :keyWord="'advantageDesc'"
                                          :params="stepdata2?stepdata2:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="潜在劣势" >
                                <rich-text :keyWord="'weaknessDesc'"
                                          :params="stepdata2?stepdata2:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="综合点评" >
                                <rich-text :keyWord="'descr'"
                                          :params="stepdata2?stepdata2:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="发展建议" >
                                <rich-text :keyWord="'suggest'"
                                          :params="stepdata2?stepdata2:''"></rich-text>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="items">
                              <div class="item-head">
                                <el-form-item label-width="40px">
                                  <el-button type="primary" plain>反思型</el-button>
                                  <el-form-item label="人格类型名称" style="width: 70%;display: inline-block;margin: 0;">
                                    <el-input placeholder="请填写人格类型名称" v-model="stepdata3.keyword"></el-input>
                                  </el-form-item>
                                </el-form-item>
                              </div>
                              <el-form-item label="解读" >
                                <rich-text :keyWord="'suggest2'"
                                          :params="stepdata3?stepdata3:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="典型优势" >
                                <rich-text :keyWord="'advantageDesc'"
                                          :params="stepdata3?stepdata3:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="潜在劣势" >
                                <rich-text :keyWord="'weaknessDesc'"
                                          :params="stepdata3?stepdata3:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="综合点评" >
                                <rich-text :keyWord="'descr'"
                                          :params="stepdata3?stepdata3:''"></rich-text>
                              </el-form-item>
                              <el-form-item label="发展建议" >
                                <rich-text :keyWord="'suggest'"
                                          :params="stepdata3?stepdata3:''"></rich-text>
                              </el-form-item>
                            </div>
                          </el-col>

                        </el-row>

                      </el-form>
                      <span slot="footer" class="public-dialog-footer">
                <!-- <el-button size="medium" @click="handleContentEdit('reset')">
                  重 置</el-button> -->
                <el-button
                    size="medium"
                    type="primary"
                    @click="handleContentEdit('add')"
                >提 交</el-button
                >
              </span>
                    </div>
                  </div>
                </el-tabs>
              </template>
            </div>
          </div>
        </template>
        <template v-if="resultMode=='lljg'">
          <div class="topic-outer" v-loading="loading" style="padding-bottom: 30px">
            <el-empty description="暂无数据" v-if="initLLJZData.length == 0"></el-empty>
            <div v-else class="appraisal-center fonts marr">
              <template v-if="initJZData">
                <el-tabs
                    tab-position="left"
                    v-model="LLJZactiveName"
                    @tab-click="handleLLJZClick"
                >
                  <el-tab-pane
                      v-for="item in initLLJZData"
                      :key="item.examResultId"
                      :label="item.code"
                      :name="item.examResultId.toString()"
                  >
                  </el-tab-pane>
                  <div>
                    <div class="public-dialog-form">
                      <el-form
                          ref="ruleForm"
                          :model="LTJTdetail"
                          label-width="110px"
                      >
                        <el-tabs type="card" v-model="languageCode" @tab-click="resultHandleTabLTJTClick">
                          <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                                      :key="index"></el-tab-pane>
                        </el-tabs>
                          <el-form-item label="综合特征" >
                            <rich-text :keyWord="'descr'"
                                        :params="LTJTdetail?LTJTdetail:''"></rich-text>
                          </el-form-item>
                          <el-form-item label="典型优势">
                            <rich-text :keyWord="'advantageDesc'"
                                        :params="LTJTdetail?LTJTdetail:''"></rich-text>
                          </el-form-item>
                          <el-form-item label="发展建议" >
                            <rich-text :keyWord="'suggest'"
                                        :params="LTJTdetail?LTJTdetail:''"></rich-text>
                          </el-form-item>


                      </el-form>
                      <span slot="footer" class="public-dialog-footer">
                <el-button
                    size="medium"
                    type="primary"
                    @click="handleLTJTEdit('add','LTJT')"
                >提 交</el-button
                >
              </span>
                    </div>
                  </div>
                </el-tabs>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--结果设置-->
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="720px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            
            :model="params"
            label-width="80px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="resultHandleTabClick2">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="一级维度">
                <div>{{ getWDData.length > 0 ? getWDData[tagIndex].name : '' }}</div>
              </el-form-item>
            </el-col>
            <template v-if="getJZData.length > 0">
            <el-col :span="12" v-if=" getJZData[tagJzIndex].name!='综合' && getJZData[tagJzIndex].name!='全部' ">
              <el-form-item label="二级基准">
                <div>{{ getJZData[tagJzIndex].name }}</div>
              </el-form-item>
            </el-col>
          </template>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="最小值" prop="minScore">
                <el-input
                    placeholder="请输入最小值"
                    v-model="params.minScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大值" prop="maxScore">
                <el-input
                    placeholder="请输入最大值"
                    v-model="params.maxScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="类型" prop="title" v-if="getWDData[tagIndex].name=='认知处理'">
                <el-input
                    placeholder="请输入类型"
                    v-model="params.title"
                    style="width: 262px"
                ></el-input>
              </el-form-item>

              <el-form-item label="等级" prop="guideSuggest" v-else>
                <el-input
                    placeholder="请输入等级"
                    v-model="params.guideSuggest"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <template v-if="
                getWDData[tagIndex].name=='荣格八维理论' || getWDData[tagIndex].name=='认知处理'
                || ((getWDData[tagIndex].name=='流体智力' || getWDData[tagIndex].name=='晶体智力')
                && (getJZData[tagJzIndex].name=='综合' || getJZData[tagJzIndex].name=='流体智力等级' 
                ||getJZData[tagJzIndex].name=='晶体智力等级'))
              ">
                <el-form-item label="关键字" prop="keyword">
                  <el-input placeholder="请输入关键字" v-model="params.keyword" style="width: 262px"></el-input>
                </el-form-item>
              </template>
            </el-col>
          </el-row>

          <!-- 综合智力 -->
          <template v-if="getWDData[tagIndex].name=='综合智力'">
            <el-form-item label="等级解读" prop="suggest2">
              <rich-text :keyWord="'suggest2'" :params="params?params:''"></rich-text>
            </el-form-item>
          </template>

          <!-- 流体/晶体智力等级综合 -->
          <template v-if="isFluidOrCrystalIntelligence">
            <!-- 综合类型显示 -->
            <template v-if="isComprehensiveType">
              <el-form-item 
                v-for="field in comprehensiveFields" 
                :key="field.prop"
                :label="field.label" 
                :prop="field.prop"
              >
                <rich-text :keyWord="field.keyWord" :params="params?params:''"></rich-text>
              </el-form-item>
            </template>

            <!-- 其他类型显示 -->
            <template v-else> 
              <el-form-item label="综述" prop="content">
                <rich-text :keyWord="'content'" :params="params?params:''"></rich-text>
              </el-form-item>
              <el-form-item 
                v-for="field in dimensionFields" 
                :key="field.prop"
                :label="field.label" 
                :prop="field.prop"
              >
                <rich-text :keyWord="field.keyWord" :params="params?params:''"></rich-text>
              </el-form-item>
            </template>
          </template>

          <!-- 认知处理 -->
          <template v-if="getWDData[tagIndex].name=='认知处理'">
            <el-form-item label="解读" prop="descr">
              <rich-text :keyWord="'descr'" :params="params?params:''"></rich-text>
            </el-form-item>
            <el-form-item label="纬度优势" prop="advantageDesc">
              <rich-text :keyWord="'advantageDesc'" :params="params?params:''"></rich-text>
            </el-form-item>
            <el-form-item label="纬度劣势" prop="weaknessDesc">
              <rich-text :keyWord="'weaknessDesc'" :params="params?params:''"></rich-text>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import richText from "../../../components/richText";
import {isEmpty, emptyShow} from "@utils/tools/index";
import Test from "../../WechatConfiguration/Test";

export default {
  components: {
    Test,
    richText,
  },
  data() {
    return {
      //之前的代码
      emptyShow, isEmpty,
      rules: {
        minScore: [
          {
            required: true,
            message: "请输入最小值",
            trigger: "blur",
          },
        ],
        maxScore: [
          {
            required: true,
            message: "请输入最大值",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        keyword: [
          {
            required: true,
            message: "请填写关键词",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写详解",
            trigger: "blur",
          },
        ],
        descr: [
          {
            required: true,
            message: "请填写字母含义",
            trigger: "blur",
          },
        ],


      },
      contentrules: {
        title: [
          {
            required: true,
            message: "请填写性格类型名称",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写性格类型详情",
            trigger: "blur",
          },
        ],
        descr: [
          {
            required: true,
            message: "请填写性格特征描述",
            trigger: "blur",
          },
        ],
        keyword: [
          {
            required: true,
            message: "请填写匹配的组织和岗位",
            trigger: "blur",
          },
        ],
        guideSuggest: [
          {
            required: true,
            message: "请填写职业推荐",
            trigger: "blur",
          },
        ],
        suggest2: [
          {
            required: true,
            message: "请填写职业建议",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},
      innerVisible: false,
      resultMode: 'jzjg',
      getJZData: [],
      tagJzIndex: 0,
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      noContentJz: false,
      dialogVisible: false,
      contentParams:[],
      currentExamResultId:'', //当前操作的结果对象ID
      languageCode: '',
      languageList: [],
      allWDData:[],
      stepdata1:{},
      stepdata2:{
        keyword:"",
        descr:"",
        advantageDesc:"",
        weaknessDesc:"",
        suggest:"",
        examId:"",
        code:"",
        examResultId:""
      },
      stepdata3:{
        keyword:"",
        descr:"",
        advantageDesc:"",
        weaknessDesc:"",
        suggest:"",
        examId:"",
        code:"",
        examResultId:""
      },
      activeindex:0,

      // 晶体&流体组合
      initLLJZData: [],
      LLJZactiveName: "",
      LTJTdetail:{}
    };
  },
  computed: {
    // 检查是否为流体智力或晶体智力
    isFluidOrCrystalIntelligence() {
      if (!this.getWDData || this.getWDData.length === 0 || this.tagIndex >= this.getWDData.length) {
        return false;
      }
      const currentDimension = this.getWDData[this.tagIndex];
      return currentDimension && (currentDimension.name === '流体智力' || currentDimension.name === '晶体智力');
    },
    
    // 检查是否为综合类型
    isComprehensiveType() {
      if (!this.getJZData || this.getJZData.length === 0 || this.tagJzIndex >= this.getJZData.length) {
        return false;
      }
      const currentJZ = this.getJZData[this.tagJzIndex];
      if (!currentJZ) return false;
      
      const comprehensiveTypes = ['综合', '流体智力等级', '晶体智力等级'];
      return comprehensiveTypes.includes(currentJZ.name);
    },
    
    // 综合类型字段配置
    comprehensiveFields() {
      return [
        { label: '典型优势', prop: 'advantageDesc', keyWord: 'advantageDesc' },
        { label: '典型劣势', prop: 'weaknessDesc', keyWord: 'weaknessDesc' },
        { label: '发展建议', prop: 'suggest', keyWord: 'suggest' }
      ];
    },
    
    // 维度类型字段配置
    dimensionFields() {
      return [
        { label: '纬度优势', prop: 'advantageDesc', keyWord: 'advantageDesc' },
        { label: '纬度劣势', prop: 'weaknessDesc', keyWord: 'weaknessDesc' },
        { label: '发展建议', prop: 'suggest', keyWord: 'suggest' }
      ];
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs.ruleForm.resetFields();
        this.params = {}
        this.innerVisible = false
      }
    }
  },
  created() {
    this.getAppraisalData();
    this.getWDList()
    this.getLanguageList()
  },
  methods: {
    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      // this.languageCode = this.languageList[0].code;
    },
     /**
     * 编辑题目时切换编辑语言
     */
     async resultHandleTabClick2(){
      if(this.currentExamResultId){
        const {data: resData} = await this.$get(`exam/result/info/${this.currentExamResultId}`,
            {
              headers: {
                isLoading: true,
                'Language-Code': this.languageCode
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true;
        this.$nextTick(()=>{
          this.$refs.resultView.scrollTo(0,0)
        })
      }
    },
    /**
     * 编辑结果时切换编辑语言
     */
    async resultHandleTabClick(){
      const ids=this.contentParams.map(item=>item.examResultId).toString();
      this.resultDetails(ids);
      this.$nextTick(()=>{
        this.$refs.resultView.scrollTo(0,0)
      })
    },
    handleTabClick() {
      if (this.resultMode == 'jzjg') {
        this.getWDList()
      } else if(this.resultMode == 'lljg') {
        this.initLLJZ()
      } else {
        this.initJZ()
      }
      this.params = {}
      this.innerVisible = false
      this.languageCode = this.languageList[0].code
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.allWDData = resData.data;
        this.getWDData = resData.data.filter((item) => item.parentId == 0 && item.nodeLevel == 1);
        if(this.getWDData.length == 0){
          this.tableData = [];
          return;
        }else{
          this.getJZData=resData.data.filter((item)=>item.parentId == this.getWDData[this.tagIndex].examDimensionId && item.nodeLevel == 2);
          this.getWdResultList();
        }
      }
    },
    /**
     * 获取测评维度结果列表
     */
    async getWdResultList() {
      this.loading = true;
      let temp = {
        examDimensionCode:this.getJZData[this.tagJzIndex].code,
        examId:this.$route.query.examId
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
    },
    /**
     * 点击维度
     */
    activeEvent(item, level,index) {
      if (level == "level1") {
        this.tagIndex = index
        this.tagJzIndex = 0;
        this.getJZData = this.allWDData.filter((items)=>items.parentId == item.examDimensionId && items.nodeLevel == 2);
      }else if (level == "level2") {
        this.tagJzIndex = index;
				this.getWdResulData = this.allWDData.filter((items)=>items.parentId == item.examDimensionId && items.nodeLevel == 3);
			}
      this.getWdResultList();
    },


    async handleClick(type, row = {}) {
      this.clickType = type;
      this.params = {};
      this.dialogVisible = true;
      this.innerVisible = false
      this.languageCode = this.languageList[0].code;
      
      if (type == "add") {
        this.params = {};
        this.innerVisible = true
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
                'Language-Code': this.languageCode
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true
        this.currentExamResultId = row.examResultId
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      if (parseInt(this.params.minScore) > parseInt(this.params.maxScore)) {
        this.$message.error('最小值不能大于最大值')
        return
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (this.clickType == "add") {
          this.params.examDimensionCode = this.getJZData[this.tagJzIndex].code;
          // this.params.examDatumCode = this.getWDData[this.tagIndex].code;
          this.params.examId = this.$route.query.examId;
          const {data: resData} = await this.$post(
              "exam/result/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code': this.languageCode
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList();
          this.dialogVisible = false;
          this.$message.success("添加成功!");
          this.params = {};
        } else {
          const {data: resData} = await this.$put(
              "exam/result/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code': this.languageCode
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList();
          this.$message.success("修改成功!");
        }
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList();
      });
    },
    //过滤标签数据
    setHtmlData(str) {
      let obj = ''
      if (str) {
        obj = str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '')
      }
      return obj
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化认知风格设置
     */
    async initJZ() {
      this.loading = true;
      const {data: resData} = await this.$post(`exam/result/init/niq/${this.$route.query.examId}/RGBW`);

      if (resData.result != 200) {
        this.loading = false;
        return;
      } else {
        this.loading = false;
        if (resData.data) {
          this.noContentJz = false
          this.jzIsShow = false;
          this.jzIsHiden = true;
          resData.data.map(item => {item.examResultContent = item.code})
          this.initJZData = resData.data;
          let id = resData.data[this.activeindex][0].examResultId;
          const ids=resData.data[this.activeindex].map(item=>item.examResultId).toString();
          this.activeName = id.toString();
          this.params.examResultId = id;
          this.resultDetails(ids);
          this.currentExamResultId = id
        } else {
          this.noContentJz = true
          this.initJZData = []
        }
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(`exam/result/niqInfo/${examResultId}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;


      this.innerVisible = true
      this.contentParams = resData.data?resData.data:[];
      let resObj = resData.data;
      this.stepdata1=resData.data[0];
      for(let i=1;i<3;i++){
        const {descr,advantageDesc,weaknessDesc,suggest,code,examResultId,keyword,suggest2}=resData.data[i];
        const data={
            suggest2:suggest2?suggest2:'',
            keyword:keyword?keyword:'',
            descr:descr?descr:'',
            advantageDesc:advantageDesc?advantageDesc:'',
            weaknessDesc:weaknessDesc?weaknessDesc:'',
            suggest:suggest?suggest:'',
            code:code?code:'',
            examId:this.$route.query.examId,
            examResultId:examResultId?examResultId:''
          }
          i==1?this.stepdata2=data:this.stepdata3=data;
      }
    },

    handleContentEdit(type) {
      if (type == "add") {
        // this.$refs.ruleForm.validate((valid) => {
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            const data=[this.stepdata1,this.stepdata2,this.stepdata3]
              const {data: resData} = await this.$put("exam/result/updateNiqExamResultList",data,
                  {
                    headers: {
                      isLoading: true,
                      'Language-Code': this.languageCode
                    },
                  }
              );
              if (resData.result != 200) return;
              
              this.$message.success("提交成功!");
          })
        // });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.contentrules = {}
          this.$message.success("重置成功!");
        })
      }
    },

    handleChangClick(tab, event) {
      this.activeindex = tab.index;
      this.activeName=tab.name;
      this.innerVisible = false
      this.$refs.ruleForm.resetFields();
      this.languageCode = this.languageList[0].code;
      const ids=this.initJZData[this.activeindex].map(item=>item.examResultId).toString();
      this.resultDetails(ids);
    },

    goBack() {
      this.$router.go(-1);
    },

    // 晶体&流体组合方法
    async initLLJZ() {
      this.loading = true;
      const {data: resData} = await this.$post(
          `/exam/result/init/niq/${this.$route.query.examId}/LTJT`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.initLLJZData=resData.data.map(item => {
          const codelist=item.code.split('');
          const [first,second,third,fourth]=codelist;
          const firstName=first=='L' || first=='l' ?'Gf':'Gc';
          const secondName=second=='D' ?'低':second=='Z'?'中':'高';
          const thirdName=third=='L' || third=='l' ?'Gf':'Gc';
          const fourthName=fourth=='D' ?'低':fourth=='Z'?'中':'高';
          item.code = firstName + secondName +'x'+ thirdName + fourthName;
          return item;
        });
        this.LLJZactiveName = resData.data[0].examResultId.toString();
        this.resultDetailsLLJZ(resData.data[0].examResultId);
      } else {
        this.initLLJZData = [];
      }
    },

    async handleLLJZClick(item, index) {
      this.LLJZactiveName=item.name;
      this.resultDetailsLLJZ(item.name);
    },

    resultHandleTabLTJTClick(tab, event) {
      this.languageCode = tab.name;
      this.resultDetailsLLJZ(this.LLJZactiveName);
    },

    // 晶体&流体组合结果详情
    async resultDetailsLLJZ(examResultId) {
      const {data: resData} = await this.$get(`exam/result/niqInfo/${examResultId}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      this.LTJTdetail=resData.data[0];      
      this.LTJTdetail['advantageDesc']=resData.data[0].advantageDesc?resData.data[0].advantageDesc:'';
      this.LTJTdetail['weaknessDesc']=resData.data[0].weaknessDesc?resData.data[0].weaknessDesc:'';
      this.LTJTdetail['suggest']=resData.data[0].suggest?resData.data[0].suggest:'';

    },
    handleLTJTEdit(type,type2) {
      this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
              const {data: resData} = await this.$put("exam/result/info",this.LTJTdetail,
                  {
                    headers: {
                      isLoading: true,
                      'Language-Code': this.languageCode
                    },
                  }
              );
              if (resData.result != 200) return;
              
              this.$message.success("提交成功!");
          })
        });
    },

  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 100%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  //margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.tag-marrs {
  border-color: #fbc4c4;
  color: #f56c6c;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  /*line-height: 20px;*/
  /*height: 46px !important;*/

}

.topic-outer .el-form-item {
  margin-bottom: 20px;
}

.topic-outer .ql-container.ql-snow {
  height: 260px;
}

.topic-outer .quill-editor.editor {
  margin-bottom: 0;
}

.on_tous_sdas .el-tabs__nav-wrap {
  width: 450px !important;
}

.on_tous_sdas .el-tabs__nav {
  width: 100% !important;
}

.on_tous_sdas .el-tabs__item {
  width: 33.33%;
  padding: 0 !important;
  text-align: center;
  line-height: 46px !important;
  font-weight: 600;
}

.on_tous_sdas .el-tabs__active-bar {
  height: 1px !important;
}

.on_tous_sdas .el-tabs__nav-wrap::after {
  height: 1px !important;
}


</style>
